(function () {
  'use strict';

  /* ── Color Definitions ── */
  const COLORS = {
    gold:   { base: '#D4AF37', light: '#F5D060', dark: '#B8960F', name: 'Dorado' },
    silver: { base: '#C0C0C0', light: '#E8E8E8', dark: '#8A8A8A', name: 'Plateado' },
    pink:   { base: '#FF69B4', light: '#FFB6D9', dark: '#D44A8E', name: 'Rosado' },
    blue:   { base: '#4169E1', light: '#7B9CFF', dark: '#2A4BB5', name: 'Azul' },
    red:    { base: '#DC143C', light: '#FF4D6A', dark: '#A80E2E', name: 'Rojo' },
  };

  /* ── State ── */
  let currentColor = 'gold';
  let croppedImage = null;   // HTMLImageElement of the cropped circular photo
  let croppedBase64 = '';
  let nameText = '';
  let dateText = '';

  /* ── Crop state ── */
  let cropImg = null;
  let cropZoom = 1;
  let cropPanX = 0;
  let cropPanY = 0;
  let cropDragging = false;
  let cropLastX = 0;
  let cropLastY = 0;

  /* ── DOM refs ── */
  const canvas = document.getElementById('balloonCanvas');
  const ctx = canvas ? canvas.getContext('2d') : null;
  const fileInput = document.getElementById('balloonPhoto');
  const uploadPlaceholder = document.getElementById('uploadPlaceholder');
  const uploadPreview = document.getElementById('uploadPreview');
  const uploadedThumb = document.getElementById('uploadedThumb');
  const removePhotoBtn = document.getElementById('removePhoto');
  const cropModal = document.getElementById('cropModal');
  const cropCanvas = document.getElementById('cropCanvas');
  const cropCtx = cropCanvas ? cropCanvas.getContext('2d') : null;
  const cropZoomInput = document.getElementById('cropZoom');
  const cropConfirmBtn = document.getElementById('cropConfirm');
  const cropCancelBtn = document.getElementById('cropCancel');
  const nameInput = document.getElementById('balloonName');
  const dateInput = document.getElementById('balloonDate');
  const colorSelector = document.getElementById('colorSelector');
  const form = document.getElementById('balloonForm');
  const addToCartBtn = document.getElementById('balloonAddToCart');
  const propFoto = document.getElementById('propFoto');
  const propNombre = document.getElementById('propNombre');
  const propFecha = document.getElementById('propFecha');
  const propColor = document.getElementById('propColor');
  const propPreview = document.getElementById('propPreview');

  if (!canvas || !ctx) return;

  /* ═══════════════════════════════════════════
     BALLOON DRAWING
     ═══════════════════════════════════════════ */

  function drawBalloon() {
    const W = canvas.width;
    const H = canvas.height;
    ctx.clearRect(0, 0, W, H);

    const color = COLORS[currentColor];
    const cx = W / 2;
    const balloonRY = 190;
    const balloonRX = 170;
    const balloonCY = 220;

    /* ── String ── */
    ctx.beginPath();
    ctx.moveTo(cx, balloonCY + balloonRY + 20);
    ctx.quadraticCurveTo(cx + 15, balloonCY + balloonRY + 80, cx - 10, H - 20);
    ctx.strokeStyle = '#999';
    ctx.lineWidth = 2;
    ctx.stroke();

    /* ── Balloon body (ellipse) ── */
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(cx, balloonCY, balloonRX, balloonRY, 0, 0, Math.PI * 2);
    const grad = ctx.createRadialGradient(
      cx - 40, balloonCY - 50, 30,
      cx, balloonCY, balloonRX
    );
    grad.addColorStop(0, color.light);
    grad.addColorStop(0.5, color.base);
    grad.addColorStop(1, color.dark);
    ctx.fillStyle = grad;
    ctx.fill();
    ctx.restore();

    /* ── Tie / knot ── */
    ctx.beginPath();
    ctx.moveTo(cx - 10, balloonCY + balloonRY);
    ctx.lineTo(cx, balloonCY + balloonRY + 22);
    ctx.lineTo(cx + 10, balloonCY + balloonRY);
    ctx.fillStyle = color.dark;
    ctx.fill();

    /* ── Circular photo inside balloon ── */
    const photoRadius = 95;
    const photoCY = balloonCY - 10;
    if (croppedImage) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(cx, photoCY, photoRadius, 0, Math.PI * 2);
      ctx.clip();
      ctx.drawImage(
        croppedImage,
        cx - photoRadius,
        photoCY - photoRadius,
        photoRadius * 2,
        photoRadius * 2
      );
      ctx.restore();

      /* Photo border */
      ctx.beginPath();
      ctx.arc(cx, photoCY, photoRadius, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(255,255,255,0.5)';
      ctx.lineWidth = 3;
      ctx.stroke();
    } else {
      /* Empty circle placeholder */
      ctx.beginPath();
      ctx.arc(cx, photoCY, photoRadius, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(255,255,255,0.35)';
      ctx.lineWidth = 2;
      ctx.setLineDash([6, 4]);
      ctx.stroke();
      ctx.setLineDash([]);

      ctx.fillStyle = 'rgba(255,255,255,0.3)';
      ctx.font = '13px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('Tu foto aquí', cx, photoCY + 5);
    }

    /* ── Highlight / shine ── */
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(cx - 55, balloonCY - 80, 25, 45, -0.4, 0, Math.PI * 2);
    const shineGrad = ctx.createRadialGradient(
      cx - 55, balloonCY - 80, 5,
      cx - 55, balloonCY - 80, 45
    );
    shineGrad.addColorStop(0, 'rgba(255,255,255,0.55)');
    shineGrad.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = shineGrad;
    ctx.fill();
    ctx.restore();

    /* ── Name text ── */
    if (nameText) {
      const textY = balloonCY + balloonRY - 50;
      ctx.save();
      ctx.font = 'bold 22px "Helvetica Neue", Helvetica, Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillStyle = '#fff';
      ctx.shadowColor = 'rgba(0,0,0,0.35)';
      ctx.shadowBlur = 4;
      ctx.shadowOffsetX = 1;
      ctx.shadowOffsetY = 1;
      ctx.fillText(nameText, cx, textY);
      ctx.restore();
    }

    /* ── Date text ── */
    if (dateText) {
      const dateY = balloonCY + balloonRY - 25;
      ctx.save();
      ctx.font = '16px "Helvetica Neue", Helvetica, Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.shadowColor = 'rgba(0,0,0,0.3)';
      ctx.shadowBlur = 3;
      ctx.fillText(dateText, cx, dateY);
      ctx.restore();
    }
  }

  /* ═══════════════════════════════════════════
     CROP FUNCTIONALITY
     ═══════════════════════════════════════════ */

  function openCropModal(imgSrc) {
    cropImg = new Image();
    cropImg.onload = function () {
      cropZoom = 1;
      cropPanX = 0;
      cropPanY = 0;
      cropZoomInput.value = 1;
      cropModal.classList.remove('hidden');
      drawCropCanvas();
    };
    cropImg.src = imgSrc;
  }

  function drawCropCanvas() {
    if (!cropCtx || !cropImg) return;
    const cw = cropCanvas.width;
    const ch = cropCanvas.height;
    cropCtx.clearRect(0, 0, cw, ch);
    cropCtx.fillStyle = '#222';
    cropCtx.fillRect(0, 0, cw, ch);

    const scale = Math.max(cw / cropImg.width, ch / cropImg.height) * cropZoom;
    const drawW = cropImg.width * scale;
    const drawH = cropImg.height * scale;
    const dx = (cw - drawW) / 2 + cropPanX;
    const dy = (ch - drawH) / 2 + cropPanY;

    cropCtx.drawImage(cropImg, dx, dy, drawW, drawH);
  }

  function getCroppedCircle() {
    /* Extract the circular region from the crop canvas */
    const size = 260; // matches the CSS crop circle size
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tctx = tempCanvas.getContext('2d');

    /* Clip circle */
    tctx.beginPath();
    tctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    tctx.clip();

    /* Calculate source region from cropCanvas center */
    const cw = cropCanvas.width;
    const ch = cropCanvas.height;
    const srcX = (cw - size) / 2;
    const srcY = (ch - size) / 2;

    tctx.drawImage(cropCanvas, srcX, srcY, size, size, 0, 0, size, size);

    return tempCanvas.toDataURL('image/png');
  }

  /* Crop canvas mouse/touch pan */
  function onCropPointerDown(e) {
    cropDragging = true;
    const pt = e.touches ? e.touches[0] : e;
    cropLastX = pt.clientX;
    cropLastY = pt.clientY;
  }

  function onCropPointerMove(e) {
    if (!cropDragging) return;
    e.preventDefault();
    const pt = e.touches ? e.touches[0] : e;
    cropPanX += pt.clientX - cropLastX;
    cropPanY += pt.clientY - cropLastY;
    cropLastX = pt.clientX;
    cropLastY = pt.clientY;
    drawCropCanvas();
  }

  function onCropPointerUp() {
    cropDragging = false;
  }

  if (cropCanvas) {
    cropCanvas.addEventListener('mousedown', onCropPointerDown);
    cropCanvas.addEventListener('mousemove', onCropPointerMove);
    cropCanvas.addEventListener('mouseup', onCropPointerUp);
    cropCanvas.addEventListener('mouseleave', onCropPointerUp);
    cropCanvas.addEventListener('touchstart', onCropPointerDown, { passive: false });
    cropCanvas.addEventListener('touchmove', onCropPointerMove, { passive: false });
    cropCanvas.addEventListener('touchend', onCropPointerUp);
  }

  if (cropZoomInput) {
    cropZoomInput.addEventListener('input', function () {
      cropZoom = parseFloat(this.value);
      drawCropCanvas();
    });
  }

  if (cropConfirmBtn) {
    cropConfirmBtn.addEventListener('click', function () {
      /* Final render to get correct pixel data */
      drawCropCanvas();
      croppedBase64 = getCroppedCircle();

      croppedImage = new Image();
      croppedImage.onload = function () {
        drawBalloon();
        /* Show thumbnail */
        uploadedThumb.src = croppedBase64;
        uploadPreview.classList.remove('hidden');
        uploadPlaceholder.classList.add('hidden');
        fileInput.classList.add('hidden');
      };
      croppedImage.src = croppedBase64;

      cropModal.classList.add('hidden');
    });
  }

  if (cropCancelBtn) {
    cropCancelBtn.addEventListener('click', function () {
      cropModal.classList.add('hidden');
      fileInput.value = '';
    });
  }

  /* ═══════════════════════════════════════════
     FILE INPUT
     ═══════════════════════════════════════════ */

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      const file = this.files[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        alert('Por favor sube una imagen válida.');
        this.value = '';
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        alert('La imagen es muy grande. Máximo 10 MB.');
        this.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = function (ev) {
        openCropModal(ev.target.result);
      };
      reader.readAsDataURL(file);
    });
  }

  if (removePhotoBtn) {
    removePhotoBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      croppedImage = null;
      croppedBase64 = '';
      uploadPreview.classList.add('hidden');
      uploadPlaceholder.classList.remove('hidden');
      fileInput.classList.remove('hidden');
      fileInput.value = '';
      drawBalloon();
    });
  }

  /* ═══════════════════════════════════════════
     TEXT INPUTS
     ═══════════════════════════════════════════ */

  if (nameInput) {
    nameInput.addEventListener('input', function () {
      nameText = this.value;
      drawBalloon();
    });
  }

  if (dateInput) {
    dateInput.addEventListener('input', function () {
      dateText = this.value;
      drawBalloon();
    });
  }

  /* ═══════════════════════════════════════════
     COLOR SELECTOR
     ═══════════════════════════════════════════ */

  if (colorSelector) {
    colorSelector.addEventListener('click', function (e) {
      const swatch = e.target.closest('.balloon-customizer__color-swatch');
      if (!swatch) return;

      colorSelector.querySelectorAll('.balloon-customizer__color-swatch').forEach(function (s) {
        s.classList.remove('active');
      });
      swatch.classList.add('active');
      currentColor = swatch.dataset.color;
      drawBalloon();
    });
  }

  /* ═══════════════════════════════════════════
     ADD TO CART
     ═══════════════════════════════════════════ */

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!croppedBase64) {
        alert('Por favor sube y recorta una foto antes de agregar al carrito.');
        return;
      }

      if (!nameText.trim()) {
        alert('Por favor escribe un nombre.');
        nameInput.focus();
        return;
      }

      /* Set hidden fields */
      propFoto.value = croppedBase64;
      propNombre.value = nameText.trim();
      propFecha.value = dateText.trim();
      propColor.value = COLORS[currentColor].name;

      /* Generate preview image from canvas */
      propPreview.value = canvas.toDataURL('image/jpeg', 0.7);

      /* Show loading */
      const btnText = addToCartBtn.querySelector('.balloon-customizer__btn-text');
      const spinner = addToCartBtn.querySelector('.balloon-customizer__spinner');
      addToCartBtn.setAttribute('aria-disabled', 'true');
      btnText.classList.add('hidden');
      spinner.classList.remove('hidden');

      /* Submit via AJAX */
      const formData = new FormData(form);

      /* If cart drawer or notification exists, add sections */
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cart = cartDrawer || cartNotification;

      if (cart) {
        const sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      }

      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            alert(data.description || 'Error al agregar al carrito.');
            return;
          }

          if (cart) {
            cart.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          alert('Hubo un error. Intenta de nuevo.');
        })
        .finally(function () {
          addToCartBtn.removeAttribute('aria-disabled');
          btnText.classList.remove('hidden');
          spinner.classList.add('hidden');
        });
    });
  }

  /* ── Initial draw ── */
  drawBalloon();

})();
